import React, { use, useEffect, useState } from 'react';
import { Form, Input, message, Modal, Select } from 'antd';
import { AuthUserVo, getTenantList, saveAuth, TenantListVo } from '@/api/auth';
import { useRequest } from 'ahooks';
import { getProcessList } from '@/api/application';

export interface EditTenantProp {
  data?: AuthUserVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditTenant = ({ data, isEdit, updateFn, onCancel }: EditTenantProp) => {
  const [form] = Form.useForm();

  const { data: tenantList } = useRequest(getTenantList);
  const { data: applicationList } = useRequest(getProcessList);

  useEffect(() => {
    if (applicationList?.length) {
      form.setFieldValue(
        'processIds',
        data?.processList?.map(item => item.id)
      );
    }
  }, [applicationList]);

  const onFinish = () => {
    form.validateFields().then(() => {
      const values = form.getFieldsValue(true);
      saveAuth({ ...values, id: data?.id }).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑租户' : '新增租户'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" initialValues={data}>
        <Form.Item name="tenantMcid" label="租户" rules={[{ required: true, message: '请输入' }]}>
          <Select
            placeholder="请选择"
            showSearch
            optionFilterProp="label"
            onChange={(_, option) => {
              const opt = option as { label?: string; value?: number };
              form.setFieldValue('tenantName', opt?.label ?? '');
            }}
            options={(tenantList ?? []).map(item => ({ label: item.name, value: item.tenantMcid }))}
          />
        </Form.Item>
        <Form.Item name="processIds" label="应用" rules={[{ required: true, message: '请输入' }]}>
          <Select
            placeholder="请选择"
            showSearch
            mode="multiple"
            optionFilterProp="label"
            options={(applicationList ?? []).map(item => ({ label: item.name, value: item.id }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditTenant;
